<template>
  <v-dialog v-model="dialog" width="400">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" :block="block" depressed tile class="orange" dark>
        Complain
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="d-flex">
        Complain Details
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pt-2">
        <v-form ref="form" v-model="isValid">
          <v-select
            label="Complain Reason"
            :items="subjects"
            v-model="form.Subject"
            :rules="rules"
            outlined
            dense
          />
          <v-textarea
            label="Remark"
            v-model="form.Remark"
            :rules="rules"
            outlined
            no-resize
            dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" @click="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { FIELD } from "../../assets/js/rules";
import rechargeService from "../../assets/services/recharge.service";
export default {
  props: {
    id: [String, Number],
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      form: {},
      isValid: false,
      rules: FIELD,
    };
  },
  computed: {
    subjects() {
      return this.$store.getters.subjects;
    },
  },
  methods: {
    init(data, AuthKey) {
      const vm = this;
      vm.dialog = true;
      vm.form = data;
      vm.AuthKey = AuthKey;
    },
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { form, id } = vm;
      form.RechargeId = id;
      try {
        vm.$loader.show();
        let res = {};
        res = await rechargeService.complaint(form);
        let { status, message } = res.data;
        vm.$loader.hide();
        if (status == "true") {
          vm.$refs.form.reset();
          vm.dialog = false;
        }
        vm.$alert.show(message);
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style>
</style>